const state = {
	data: {
		auth_token: '',
		auth_push_notification_token: '',
		user_login: {},
		user_selected: {},
		permissions: [],
		accounts: []
	}
}

const getters = {
	PERMISSIONS : state => {
		return state.data.permissions
	},
	ACCOUNTS : state => {
		return state.data.accounts
	},
	FIND_ACCOUNTS : state => user_uid => {
		return [...state.data.accounts, state.data.user_login].find(item => {
			return item.uid === user_uid
		})
	},
	USER : state => {
		return state.data.user_login
	},
	CURRENT_USER : state => {
		return state.data.user_selected
	},
	CURRENT_USER_UID : state => {
		return state.data.user_selected.uid
	},
	IS_AUTHENTICATED : state => {
		return state.data.auth_token !== ''
	}
}

const mutations = {
	GET_USER : (state, payload) => {
		state.data.user_login = payload.user
		state.data.permissions = payload.permissions
		state.data.accounts = payload.accounts
	},
	SET_CURRENT_USER : (state, user) => {
		state.data.user_selected = user
	},
	SET_AUTH : (state, token) => {
		state.data.auth_token = token
	},
	CLEAN_AUTH : (state) => {
		state.data.auth_token = ''
	},
}

const actions = {
	GET_USER : async (context, { refThis, user_uid }) => {
		let { data } = await refThis.$api.users.getCompletedByUid(refThis, user_uid)
		context.commit('GET_USER', data)
	},
	CHANGE_USER : (context, user) => {
		context.commit('SET_CURRENT_USER', user)
	},
	SET_AUTH : (context, token) => {
		context.commit('SET_AUTH', token)
	},
	CLEAN_AUTH : (context) => {
		context.commit('CLEAN_AUTH')
	},
}

export default {
	state, getters, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js